import CheckboxInput from "@stadium/ui/src/components/form/CheckboxInput";
import Multimedia from "@stadium/ui/src/components/multimedia/multimedia";
import Label from "@sharedComponents/form-label";
import ToolTip from "@stadium/ui/src/components/tooltip/tooltip";

import styles from "./swag-multiple-options.module.scss";

const SwagMultipleOptionsSelector = ({
  availData = [],
  selectedData: selectedIds = [],
  handleChange = () => {},
  productId = "product",
  disabled = false,
}) => {
  const toggleOption = (option) => {
    const isSelected = selectedIds.includes(option.id);
    const nextSelected = isSelected
      ? selectedIds.filter((id) => {
          return id !== option.id;
        })
      : [...selectedIds, option.id];

    handleChange(nextSelected);
  };

  return (
    <div className={styles.productColorWrapper}>
      {availData.map((option) => {
        const checked = selectedIds.includes(option.id);
        const inputId = `${productId}-${option.id}`;
        const isSelected = selectedIds.includes(option.id);

        return (
          <ToolTip
            key={inputId}
            content={option.presentation}
            isLightTheme={true}
            placement="top-start"
            arrow
          >
            <CheckboxInput
              id={inputId}
              checked={checked}
              disabled={disabled}
              onChange={() => toggleOption(option)}
              label={
                <Label
                  iconType="check"
                  showIcon={false}
                  className={`${styles.productImageWrapper} ${
                    isSelected ? styles.selectedImageWrapper : ""
                  }`}
                >
                  <Multimedia
                    type="image"
                    src={option.image}
                    alt={option.presentation || option.name || String(option.id)}
                    height={68}
                    width={68}
                    isNextImage={false}
                  />
                </Label>
              }
            />
          </ToolTip>
        );
      })}
    </div>
  );
};

export default SwagMultipleOptionsSelector;
